// Copyright (c) 2017 Comsearch, Inc., All rights reserved

import { error, success } from 'react-notification-system-redux'
import { checkModulationStatus } from 'helpers/api'
import { removeModulationFromState } from 'redux/modules/databaseDetails'

const notification = message => ({
  autoDismiss: 3,
  dismissible: false,
  message,
})

const removeModulation = id => async (dispatch, getState) => {
  // if the radio modulation id is a string, then it's a new modulation that hasn't
  // been stored in the DB yet. only for existing modulations do we need to hit the API
  // to see if the modulation is being used in a favorite or a segment_end.
  if (+id) {
    try {
      await checkModulationStatus(id)
    } catch (err) {
      console.warn(err)
      const message = 'Error: ' + (
        err.json.entity || err.message ||
        'Cannot delete a modulation that is used on a path or a radio favorite.'
      )
      return dispatch(error(notification(message)))
    }
  }

  // get the index of the modulation to remove, pass this to the reducer
  const modIndex = (
    getState().databaseDetails
      .getIn(['initialValues', 'radioModulations'])
      .findIndex(d => d.get('radioModulationId') === id)
  )
  await dispatch(removeModulationFromState(modIndex))
  await dispatch(success(notification('Modulation was deleted successfully.')))
}

export default removeModulation
